import * as React from 'react';
import { Select, type SelectOption } from './select';

export interface CurrencyItem {
  code: string;
  name: string;
}

export interface CurrencySelectProps {
  value?: string;
  onChange?: (value: string) => void;
  currencies: CurrencyItem[];
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  className?: string;
  id?: string;
  searchPlaceholder?: string;
  noResultsText?: string;
}

const CurrencySelect = React.forwardRef<HTMLButtonElement, CurrencySelectProps>(
  (
    {
      value,
      onChange,
      currencies,
      placeholder = 'Select currency',
      disabled = false,
      error = false,
      className,
      id,
      searchPlaceholder = 'Search...',
      noResultsText = 'No currency found.',
    },
    ref,
  ) => {
    const options: SelectOption[] = React.useMemo(
      () =>
        currencies.map((c) => ({
          value: c.code,
          label: `${c.code} — ${c.name}`,
        })),
      [currencies],
    );

    return (
      <Select
        ref={ref}
        id={id}
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        error={error}
        className={className}
        searchable
        searchPlaceholder={searchPlaceholder}
        noResultsText={noResultsText}
      />
    );
  },
);
CurrencySelect.displayName = 'CurrencySelect';

export { CurrencySelect };
